import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './actions';

class EnableSwitch extends Component {
    onClick(use) {
        this.props.dispatch(Action.do('usePlayerCombinationStacking', !use));
    }

    render() {
        const {stacking} = this.props;

        return (
            <div className="lineup-control">
                <div className="lineup-control-holder">
                    <div className="filter-btn-group">
                        <button
                            type="button"
                            className={!stacking.isEnabled() ? 'active' : ''}
                            onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        >
                            Off
                        </button>
                        <button
                            type="button"
                            className={stacking.isEnabled() ? 'active' : ''}
                            onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        >
                            On
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playerCombinationStacking} = state;

    return {
        stacking: playerCombinationStacking,
    };
}

export default connect(mapStatesToProps)(EnableSwitch);
